import { FC } from 'react';
import { useCSVReader } from 'react-papaparse';
import { ParseResult } from 'papaparse';
import { Box } from '@mui/system';
import { Button, Typography } from '@mui/material';

export type CsvCampaign = { [key: string]: any };
export const CAMPAIGN_VALID_HEADERS = ['customer_id'];

type Props = {
  addInvalidHeader: (header: string) => void;
  addValidationError: (error: string) => void;
  clearState: () => void;
  setCustomers: (custs: any) => void;
};

const convertCsvToCustomerIdArray = (csv: ParseResult<string[]>, addInvalidHeader: (header: string) => void) => {
  const headers: string[] = csv.data[0];

  // Validate Headers
  headers.forEach((header) => {
    const headerIsValid = CAMPAIGN_VALID_HEADERS.includes(header);

    if (!headerIsValid) {
      addInvalidHeader(header);
    }
  });

  const rows = csv.data.slice(1);

  return rows.map((row) => {
    return headers.reduce(
      (campaign: CsvCampaign, header: string, i: number) => ({
        ...campaign,
        [header]: row[i],
      }),
      {},
    );
  });
};

const CampaignCsvReader: FC<Props> = ({ addInvalidHeader, addValidationError, setCustomers, clearState }) => {
  const { CSVReader } = useCSVReader();

  return (
    <CSVReader
      onUploadAccepted={(results: any) => {
        clearState();
        const csvCampaigns = convertCsvToCustomerIdArray(results, addInvalidHeader);

        const customers = csvCampaigns.map((cust) => cust.customer_id);

        // Remove duplicate customer ids
        const uniqueCustomers = Array.from(new Set(customers));

        setCustomers(uniqueCustomers);
      }}
    >
      {({ getRootProps, acceptedFile }: any) => (
        <Box minWidth={400}>
          <Typography variant="subtitle1" mb={1}>
            {(acceptedFile && acceptedFile?.name) || 'No file selected'}
          </Typography>
          <Button variant="outlined" component="span" {...getRootProps()}>
            {acceptedFile ? 'Choose another file' : 'Choose file'}
          </Button>
        </Box>
      )}
    </CSVReader>
  );
};

export default CampaignCsvReader;
